import { getLocale } from "./getLocales";

const formatPrice = (price: number, currencyCode = "USD"): string => {
  const normalizedCurrency = currencyCode.trim().toUpperCase();
  // en-US + narrowSymbol renders "$9.99" instead of "US$9.99" for USD.
  const locale = normalizedCurrency === "USD" ? "en-US" : getLocale();

  try {
    return price.toLocaleString(locale, {
      style: "currency",
      currency: normalizedCurrency,
      currencyDisplay: "narrowSymbol",
    });
  } catch (err) {
    // A blank/malformed currency code (e.g. from an upstream Paddle payload)
    // makes Intl throw a RangeError. Never let a price fail to render —
    // fall back to a plain number so the component tree doesn't crash.
    console.error(
      `formatPrice: invalid currency code "${currencyCode}", falling back to plain number formatting.`,
      err
    );
    const amount = price.toLocaleString(locale);
    return normalizedCurrency ? `${normalizedCurrency} ${amount}` : amount;
  }
};

export { formatPrice };
